import {alias, createModelSchema, reference} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {RewardModel} from "../reward/RewardModel";
import {GuardConfig} from "../guard/GuardConfig";
import {Money} from "@/modules/redactor/models/currency/Money";
import {ItemOrderKind} from "./ItemOrderKind";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class ItemOrder extends BaseObject {

    static schema() {
        return reference("uid", (uid, cb) => {
            return cb(null, RedactorUtils.getItemOrder(uid));
        });
    }

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._kind = ItemOrderKind.NONE;

        this._guard = null;
        this._price = null;
        this._reward = null
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get price() {
        return this._price;
    }

    set price(value) {
        this._price = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (!this.kind || !ItemOrderKind.is(this.kind)) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (!this.price || !this.price.valid() || this.price.empty()) {
            return false;
        }

        if (!this.reward || !this.reward.valid() || this.reward.empty()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemOrder());
        } else if (target instanceof ItemOrder) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemOrder, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _kind: alias("kind", ItemOrderKind.schema()),
    _guard: alias("guard", GuardConfig.schema()),
    _price: alias("price", Money.schema()),
    _reward: alias("reward", RewardModel.schema())
});